import React, { Fragment } from 'react';
import Loader from '../common/Loader';
import { Button, Card, CardBody, Row, Col } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Heading from '../common/Heading';

const SupportTicketDetail = () => {
  // const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const ticket = location.state;

  console.log('ticket:', location.state);
  return (
    <Fragment>
      <Heading title="Support case" subtitle="View your support case" className="mb-4 mt-3" icon="life-ring" />
      <Row className="flex-between-center mb-2">
        <Col xs="auto">
          <Button
            color="falcon-default"
            size="sm"
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </Col>
      </Row>
      <Card bg={'light'} text={'dak'} className="mb-4">
        <CardBody>
          <Row>
            <Col lg="12">
              {!ticket ? (
                <Loader text="Loading ticket..." />
              ) : (
                ticket.map(item => {
                  return item.label === 'Description' ? (
                    item.value.map(subItem => {
                      const division = subItem.split(':');
                      const descLabel = division.shift();
                      console.log('division', division);
                      // const descContent =
                      return (
                        <p key={subItem} data-testid={'description-content'}>
                          <span className="font-weight-bold" data-testid={'description-label'}>
                            {descLabel}:{' '}
                          </span>
                          {/* {descContent} */}
                          {/* {item.value.replace(/\n/g, '<br />')} */}
                          {division[0]}
                        </p>
                      );
                    })
                  ) : (
                    <p key={item.label} data-testid={item.label + '-content'}>
                      <span className="font-weight-bold" data-testid={item.label + '-label'}>
                        {item.label}:{' '}
                      </span>
                      {item.value}
                    </p>
                  );
                })
              )}
            </Col>
            <Col lg="6" />
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default SupportTicketDetail;
